import { AllowedFileTypesLabels } from '../types/programModulesAndContents';

export const allowedFilesOptions = Object.entries(AllowedFileTypesLabels).map(
  ([key, label]) => ({
    value: key,
    label,
  })
);
